import React from "react";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from "swiper";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import CreativeNameDisplay from "../shared/CreativeNameDisplay";

function GalleryPreview({ preview }) {
  // 1. Guard against null/undefined preview
  if (!preview) return null;

  // 2. Normalize image data to avoid messy logic in the JSX
  // If edit is true, use gallery; otherwise use img_urls. Fallback to empty array.
  const rawImages = preview?.gallery  ? preview.gallery : preview?.img_urls ? preview.img_urls : [];
  return (
    <>
      <CreativeNameDisplay preview={preview} />
      <div className="preview-inner">
        <div className="preview-gallery">
          <Swiper
            spaceBetween={50}
            pagination={true}
            navigation={true}
            modules={[Navigation, Pagination]}
            className="mySwiper h-full"
          >
            {/* 3. Safe mapping with optional chaining */}
            {(rawImages) ?.map((imgLink, index) => {
              // Handle the difference between object {image: url} and string url
              const imageSrc =  imgLink?.image  ? imgLink?.image : imgLink;
              
              if (!imageSrc) return null;

              return (
                <SwiperSlide key={index}> 
                  <img 
                    src={imageSrc} 
                    alt={`gallery-item-${index}`} 
                    className="w-full !h-[95%]" 
                  /> 
                </SwiperSlide>
              );
            })}

            {/* Logo overlay/slide */}
            <div className="logo-container">
               <img 
                src="https://d30365bzukh5e5.cloudfront.net/share_content_imgs/telugu_new3_v8.png" 
                alt="way2news-logo" 
              />
            </div>
          </Swiper>
        </div>
      </div>
    </>
  );
}

export default GalleryPreview;